import { CELL_DISPLAY_SETTINGS } from "@lib/base/modules/table/cell-display-settings";
import { TokenType } from "@lib/base/types/angular.types";

export const cellDisplaySettingsProvider = {
    provide: CELL_DISPLAY_SETTINGS,
    useValue: {
        animateInputChanges: true,
        animateComponentChanges: true,
    } satisfies TokenType<typeof CELL_DISPLAY_SETTINGS>,
};
